export const environment = {
    production: false,
    //API_RETURN_REQUEST: "https://return-tecnic-dev.cc.cloudintercorpretail.pe/api/customer-care/return_requests"
    API_RETURN_REQUEST: "https://api-ost-dev.cc.cloudintercorpretail.pe/v1/response-mail"
};